import React, { useMemo } from 'react';

interface Props {
  src: string;
  onClose: () => void;
}

const ReceiptLightbox: React.FC<Props> = ({ src, onClose }) => {
  const styles = useMemo(() => getStyles(), []);

  return (
    <div onClick={onClose} style={styles.overlay}>
      <img src={src} onClick={e => e.stopPropagation()} style={styles.image} />
    </div>
  );
};

const getStyles = () => ({
  overlay: {
    position: 'fixed' as const,
    inset: 0,
    background: 'rgba(0,0,0,0.75)',
    display: 'flex' as const,
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    zIndex: 9999,
    cursor: 'zoom-out' as const
  },
  image: {
    maxWidth: '90vw',
    maxHeight: '90vh',
    objectFit: 'contain' as const,
    boxShadow: '0 4px 24px rgba(0,0,0,0.5)',
    cursor: 'default' as const
  }
});

export default ReceiptLightbox;
